import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
const faqs = [{
  q: 'Ist DER REHA-CODE 360° wirklich für Anfänger ohne klinische Erfahrung?',
  a: 'Ja. Wir starten mit Anatomie-Basics und bauen alles Schritt für Schritt auf. Kein Jargon, nur klare Konzepte.'
}, {
  q: 'Kann ich das System auch ohne teures Equipment verwenden?',
  a: 'Absolut. Boni 2 zeigt komplette Körpergewicht-Protokolle. Boni 3 erklärt Warm-up mit Alltags-Items.'
}, {
  q: 'Sind die Protokolle real oder nur Theorie?',
  a: '100% praktisch. Sie stammen aus Physiotherapie-Praxen, CrossFit-Boxen und Profisport-Teams. Sofort anwendbar.'
}, {
  q: 'Wie schnell sehe ich Ergebnisse mit meinem ersten Klienten?',
  a: 'Die meisten Nutzer erstellen nach Band 1 ein Beurteilungsformular. Nach Band 2-3 verschreiben sie progressiv. Nach Band 6 sind sie echte Experten. Das sind 4-6 Wochen bei 30 Min/Tag.'
}, {
  q: 'Brauche ich andere Kurse?',
  a: 'Nein. DER REHA-CODE 360° ist ein vollständiges System. Die 6 Bände + 5 Boni decken 95% aller häufigen Verletzungen.'
}, {
  q: 'Was, wenn ich nicht täglich Zeit zum Lernen habe?',
  a: 'Kein Problem. 30-Minuten-Sessions funktionieren genauso gut. Oder 2 Stunden am Wochenende.'
}, {
  q: 'Gibt es Support, wenn ich steckenbleibe?',
  a: 'Ja. E-Mail-Support ist inklusive. Antwort innerhalb 24 Stunden.'
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section aria-label="Häufig gestellte Fragen" className="bg-transparent" data-id="element-56" data-mp="16o7ayqc2k8qn">
      <div className="mx-auto max-w-3xl px-5 py-12" style={{
      paddingTop: "14px",
      paddingBottom: "14px"
    }} data-id="element-57" data-mp="rzb4uytkp5so">
        <h2 className="text-center font-display text-3xl font-black text-grape sm:text-4xl" data-id="element-58" data-mp="wxmf3ans5ibf">
          ❓ Häufig gestellte Fragen
        </h2>
        <div className="mt-10 divide-y divide-grape/10 overflow-hidden rounded-2xl border border-grape/15 bg-white" data-id="element-59" data-mp="iywhltx1tgmj">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <div key={f.q} data-id="element-60" data-mp="2pnf0t8i31vqy" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left transition-colors duration-150 ease-out hover:bg-lilac-soft focus:outline-none focus-visible:bg-lilac-soft" data-id="element-61" data-mp="2poq4z9ffx5il">
                  <span className="text-sm font-bold text-plum sm:text-base" data-id="element-62" data-mp="2azk5dkcoxda6">{f.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grape" data-id="element-63" data-mp="38kpwkj4ia71n" /> : <PlusIcon className="h-5 w-5 shrink-0 text-plum/40" data-id="element-64" data-mp="33m4vyilcdlco" />}
                </button>
                <div className="grid transition-[grid-template-rows] duration-300 ease-out" style={{
              gridTemplateRows: isOpen ? '1fr' : '0fr'
            }} data-id="element-65" data-mp="2ymjy6bhwrj1j">
                  <div className="overflow-hidden" data-id="element-66" data-mp="2uo2mdenjlkds">
                    <p className="px-6 pb-5 text-sm leading-relaxed text-plum/70" data-id="element-67" data-mp="1n8xyhwef9z1r">{f.a}</p>
                  </div>
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}